module.exports = __webpack_public_path__ + "static/media/bg_catalog.e4da72bb.png";